import { render, staticRenderFns } from "./outpatientRecord.vue?vue&type=template&id=945e86f0&scoped=true&"
import script from "./outpatientRecord.vue?vue&type=script&lang=js&"
export * from "./outpatientRecord.vue?vue&type=script&lang=js&"
import style0 from "./outpatientRecord.vue?vue&type=style&index=0&id=945e86f0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "945e86f0",
  null
  
)

export default component.exports